<template>
    <div v-if="showBox" :class="[ 'rectClass' ]" >
        <div :class="shit$(`dis:f; justify-c:sb; align-i:c; pl:27px; pr:27px; mb:17px;`)">
            <span :class="shit$(`font:20px; letter-s:1.47px; font-w:500; `)">{{this.$t( "code-lab/component/intro/introBox.vue_0" ) }}</span>
            <span @click="close"  :class="shit$(`cursor:p;`)">
                <i :class="[ 'el-icon-close', shit$(`font:20px; font-w:bold;`) ]"></i>
                <!-- <svg-icon href="#close-button-icon" :width="23" :height="24"></!-->
            </span>
        </div>
        <template v-if="showMissionIntro">
            <div @mouseenter="enter(0)" @mouseleave="leave(0)" @click="toggle(0)" :class="shit$(`dis:f; align-i:c; mih:96px; lh:1.4; pl:27px; pr:27px; pt:8px; pb:8px; hover:bgc:#272727;`)">
                <span>
                    <svg-icon :href="'#button-icon-mission' + (crt === 0 ? '-active' :'')" :width="45" :height="45"></svg-icon>
                </span>
                <div :class="shit$(`dis:f; flex-d:c;  ml:21px;`)">
                    <span :class="[ shit$(`letter-s:1.2px; font:18px; font-w:normal;`), crt === 0 && shit$(`c:#0ed3ff;`)]">{{this.$t( "code-lab/component/intro/introBox.vue_1" ) }}</span>
                    <span :class="shit$(`c:#a8a8ac; letter-s:0.9px; font:14px; font-w:300;`)">{{this.$t( "code-lab/component/intro/introBox.vue_2" ) }}</span>
                </div>
            </div>
        </template>
        <template v-if="!noGetSimulatorKey">
            <div @mouseenter="enter(1)" @mouseleave="leave(1)" @click="toggle(1)" :class="shit$(`dis:f; align-i:c; mih:96px; lh:1.4; pl:27px; pr:27px; pt:8px; pb:8px; hover:bgc:#272727;`)">
                <span>
                    <svg-icon :href="'#button-icon-simulator' + (crt === 1 ? '-active' :'')" :width="45" :height="45"></svg-icon>
                </span>
                <div :class="shit$(`dis:f; flex-d:c;  ml:21px;`)">
                    <span :class="[ shit$(`letter-s:1.2px; font:18px; font-w:normal;`), crt === 1 && shit$(`c:#0ed3ff;`) ]">{{this.$t( "code-lab/component/intro/introBox.vue_3" ) }}</span>
                    <span :class="shit$(`c:#a8a8ac; letter-s:0.9px; font:14px; font-w:300;`)">{{this.$t( "code-lab/component/intro/introBox.vue_4" ) }}</span>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mutations as exchangeutations } from '@/code-lab/component/exchange/observable.js'
import { mapState } from 'vuex'
const Cookies = window.Cookies;
export default {
    data () {
        return {
           crt: -1,
           langs: [ 'zh-TW', 'ja-JP', 'en-US' ]
        }
    },
    computed: {
        ...mapState('introStore', {
            showBox: 'showBox'
        }),
        showMissionIntro () { return this.langs.includes(Cookies.get("langCode")) },
        noGetSimulatorKey () { return exchangeutations.isEmpty('simulator') },
    },
    methods: {
        enter (val) {
            this.crt = val
        },
        leave () {
            this.crt = -1
        },
        openSimulator () {
            this.$store.commit("SELECTEDMENUERIGHT", null)
            this.$store.commit("SHOW_SIMULATOR", true)
            this.$store.dispatch ('introStore/excuteStackSimulator_', [ { type: 'simulatorDB', index: 0 } ])
        },
        openMission () {
            this.$store.commit('introStore/upShowMissionIntro', [ true ])
        },
        toggle (val) {
            val === 0 ? this.openMission() : this.openSimulator()
            this.$store.commit('introStore/upShowBox', [ false ])
        },
        close () {
            this.$store.commit('introStore/upShowBox', [ false ])
        }
    },
}
</script>

<style scoed>
    .rectClass {
        width: 370px;
        box-shadow: 0 0 3px 1px rgba(31, 31, 31, 0.5);
        background-color: #333333;
        position: fixed;
        bottom: 10px;
        left: 74px;
        z-index: 1999;
        padding: 27px 0px 13px 0px;
        color: #ffffff;
    }
</style>
